import {gql} from '@apollo/client';

import {doQueryWithoutCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {BioentityQuery, BioentityQueryVariables} from './__generated/BioentityQuery';

const BIOENTITY_QUERY = gql`
  query BioentityQuery($input: RegistryInput!) @skipAudit @engComponent(name: REGISTRY) {
    directBioentity(input: $input) {
      ...BioentitySummaryOrInaccessibleGraphQL
      ... on SequenceNode {
        id
        name
        tagsJson
        basesIfShowResidues
        bases
        circular
        modifiedNucleotides {
          position
          sugarMonomerId
          baseMonomerId
          phosphateMonomerId
        }
        helmString
        idtString
        customSyntaxString
        existingFeatures
      }
      ... on MoleculeNode {
        id
        canonicalSmiles
      }
      ... on ProteinNode {
        id
        versionJson
      }
      ... on AaSequenceNode {
        id
        versionJson
      }
    }
  }
  ${getFragmentWrapper('BioentitySummaryOrInaccessible').fragment}
`;

export default async function doBioentityQuery(
  bioentityId: string,
  customSyntaxName?: string | null
): Promise<BioentityQuery> {
  return await doQueryWithoutCache<BioentityQuery, BioentityQueryVariables>(
    {query: BIOENTITY_QUERY},
    {variables: {input: {id: bioentityId, customSyntaxName}}}
  );
}
